/* eslint-disable no-restricted-globals,no-alert,object-curly-newline */
/* global G */
import { curry, setKey } from 'lib/util'
import { actionFn } from 'lib/sequence/module/action'
import find from 'lib/sequence/component/children/find'
import findDevices from 'app/_shared/events/device/find'
import sequenceComponentState from 'lib/sequence/component/state'
import { persistChange } from 'app/_shared/events'
import selectItem from 'app/serviceItem/event/selectItem'
import reset from 'lib/sequence/model/api/reset'

const {
  unset: clearError,
} = sequenceComponentState('error')

const {
  unset: clearHelperText,
} = sequenceComponentState('helperText')

const clear = component => clearError(component) && clearHelperText(component)

/**
 * Event Handler Search Device
 *
 * Attempts to find a service item or equipment by its serial and, depending on what is found, sets
 * the current model's item, equipment and product attributes with their information. Otherwise, if
 * nothing is found, those model attributes are cleared.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Gaia.PlatformEvent} event    the event object that triggered this handler
 * @returns {Promise<void>}
 */
const searchDevice = async (module, component, event) => {
  event.preventDefault()
  event.stopPropagation()

  const moduleState = module[G.STATE]
  const actionComponent = moduleState[G.ACTION][G.COMPONENT]
  const model = module[G.MODEL]
  const serialValue = event.detail.value
  const { resultsModal, resultsList } = find(actionComponent)

  persistChange(module, component, event)
  // clearing field state
  clear(component)
  reset(model)
  setKey(false, G.ERROR, model[G.STATE])

  if (serialValue) {
    const devices = await findDevices(module, component, event)

    if (devices?.length > 1) {
      setKey(true, 'open', resultsModal[G.STATE])
      setKey({ term: serialValue }, G.META, resultsList[G.STATE])
    } else {
      await selectItem(module, component, devices?.[0])
    }
  }

  await actionFn(module[G.STATE][G.ACTION])()
  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(searchDevice)
